/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 李勇
 * @Date: 2023-10-26 14:29:17
 * @LastEditors: 李勇
 * @LastEditTime: 2023-10-26 14:29:25
 * @FilePath: /partner.chaoyongtuan.com/src/utils/newDataMap/sampleOrder.js
 *
 * Copyright (c) 2023 by 央选/李勇, All Rights Reserved.
 */

//样品订单分销类型
export const retailInfoArr = [
	{
		label: '全部',
		value: '-1',
	},
	{
		label: '达人分销',
		value: '0',
	},
	{
		label: '团长分销',
		value: '1',
	},
];

//样品订单带货类型
export const sellGoodsTypeArr = [
	{
		label: '全部',
		value: '-1',
	},
	{
		label: '不限',
		value: '0',
	},
	{
		label: '直播',
		value: '1',
	},
	{
		label: '短视频',
		value: '2',
	},
];

//样品订单协作状态
export const orderCooperateList = [
	{
		label: '待绑定商团协作',
		value: '0',
	},
	{
		label: '待同步',
		value: '1',
	},
	{
		label: '待商家处理',
		value: '2',
	},
	{
		label: '处理中',
		value: '3',
	},
	{
		label: '已完成',
		value: '4',
	},
	{
		label: '同步失败',
		value: '5',
	},
];
export default {};
